<template>
<div class="item">
  <div class="header">
    <span @click="Rout">诚邀加盟</span><i class="el-icon-arrow-right"></i><span>招聘详情</span>
  </div>
  <div class="content">
    <div class="first">
      <div class="left">
        <span>{{data.post}}</span>
        <span> 杭州 | 本科 | 招30人 | {{data.updateTime}}发布</span>
      </div>
      <div class="right">
        <span>{{data.salary}} / 月</span>
      </div>
    </div>
    <div class="second">
      <div class="top"><span>岗位职责</span></div>
      <div class="bottom"> {{data.duty}}</div>
    </div>
    <div class="third">
      <div class="top"><span>岗位要求</span></div>
      <div class="bottom"> {{data.demand}}</div>
    </div>
    <div class="fourth">
      <div class="top"><span>联系方式</span></div>
      <div class="bottom">
        <p>服务热线 : {{data.phoneNumber}}</p>
        <p>公司地址:杭州市下城区华丰路317号创意园4号楼3楼</p>
        <p>邮箱 : {{data.email}}</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: "JoinDetail",

  computed:{
    data(){
      return this.$store.state.JoinData
    }
  },
  methods:{
    Rout(){
      this.$router.push('/join')
    }
  }
}
</script>

<style lang="less" scoped>
.item{
  min-height: 1000px;
}
.header{
  height: 44px;
  background: #F6F7F8;
  line-height: 44px;
  padding-left: 16.6%;
  i{
    font-size: 12px;
  }
  span{
    width: 48px;
    height: 12px;
    font-size: 12px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #666666;
    line-height: 18px;

  }
}
.first{
  width: 66.7%;
  min-height: 19.4vh;
  margin: 0 auto;
  display: flex;
  justify-content: space-between ;
  border-bottom: 1px solid gainsboro;
  align-items: center;
  .left{
    span{
      display: block;
      margin-bottom: 25px;
      &:first-child{
        height: 24px;
        font-size: 24px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 36px;
      }
      &:last-child{
        height: 16px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }
    }
  }
  .right{
    span{
      height: 24px;
      font-size: 24px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #F98B00;
      line-height: 36px;
    }
  }
}
.second{
  width: 66.7%;
  min-height: 19.4vh;
  margin: 0 auto;
  padding-top: 4vh;
  border-bottom: 1px solid gainsboro;
}
.third{
  width: 66.7%;
  min-height: 19.4vh;
  margin: 0 auto;
  padding-top: 4vh;
  border-bottom: 1px solid gainsboro;
}
.fourth{
  width: 66.7%;
  min-height: 19.4vh;
  margin: 0 auto;
  padding-top: 4vh;
}
.top{
  border-left: 4px solid #188ACB;
  border-radius: 1px;
  padding-left: 10px;

  span{
    height: 18px;
    font-size: 18px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #333333;
    line-height: 27px;

  }
}
.bottom{
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
  margin-top: 20px;
  padding-left: 3px;
}
</style>